import { Outlet } from "react-router-dom";

export default function ShopInner() {
  return <Outlet />;
}
